import React, {Component} from 'react';
import { Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { compose  } from 'redux';
import { fetchNavigationData } from '../../actions/navigationData';
import classes from './Blog.css'

import Navigation from '../../components/Navigation/Navigation';
import LinkPage from '../../components/Page/LinkPage/LinkPage';

// will be set by redux connection later!
const DEFAULT_NAV_DATA = {
  items: [
    { type: 'navItem', name: 'home', src: 'https://bunny-ufo-blog-sites.s3.us-west-2.amazonaws.com/daniel_typography/index.html'}
  ]
}

class Blog extends Component {
  state = {
    navigationState: 'closed',
    contentSource: DEFAULT_NAV_DATA['items'][0]['src'],
    selectedItems: [0],
    accordionKeys: []
  }

  componentDidUpdate(prevProps) {
    if (prevProps.navigationData != this.props.navigationData) {
      var routes = this.getAllRoutes()
      var matchingRoute = routes.filter((route) => route.routeName === this.props.history.location.pathname);
      if ( matchingRoute.length <= 0){
        this.props.history.push(routes[0].routeName);
      }
    }
  }

  navigationData = () => {
    let navigationDataLoaded = !!this.props.navigationData && !!this.props.navigationData['items']
    return navigationDataLoaded ? this.props.navigationData: DEFAULT_NAV_DATA
  }

  setContentPath = (itemIndex) => {
    this.setState({selectedItems: itemIndex});
  }

  navigationIcon = () => {
    let classNames = {
      'closed':  'visible',
      'opening': 'hiding',
      'open': 'hidden',
      'closing': 'hidden',
    }

    return (
      <div className={'navigation-icon ' + classNames[this.state.navigationState]}
        onMouseEnter={() => this.openNavigation()}
        onClick={() => this.openNavigation()}
      />
    )
  }

  navigation = () => {
    this.generateRoutes();

    return (
      <div
        className={'navigation-panel ' + this.state.navigationState}
        onTransitionEnd={(transitionEvent) => this.setFinalNavigationState(transitionEvent)}
        onMouseEnter={() => this.openNavigation()}
        onMouseLeave={() => this.setState({navigationState: 'closing'})}
      >
        <Navigation
          navData={this.navigationData()}
          setContentPath={this.setContentPath}
          setAccordionKeys={this.setAccordionKeys}
          navigateForward={this.navigateForward}
          navigateBack={this.navigateBack}
          accordionKeys={this.state.accordionKeys}
          selectedItems={this.state.selectedItems}
          />
      </div>
    )
  }

  openNavigation = () => {
    if (this.state.navigationState === 'closing' || this.state.navigationState === 'closed') {
      this.setState({navigationState: 'opening'});
    }
  }

  setAccordionKeys = (accordionKeys) => {
    this.setState({
      accordionKeys: accordionKeys,
    });
  }


  closeNavigatiaon = () => {
    if (this.state.navigationState === 'open' || this.state.navigationState === 'opening') {
      this.setState({navigationState: 'closing'});
    }
  }

  setFinalNavigationState = (transitionEvent) => {
    if (!transitionEvent.target.className.split(/\s/).includes('navigation-panel')) return;
    if (this.state.navigationState === 'closing') {
      this.setState({navigationState: 'closed', accordionKeys: []});
    }
    else if (this.state.navigationState === 'opening') {
      this.setState({navigationState: 'open'});
    }
  }

  getAllRoutesRecursive = (navItems, path, routes) => {
    navItems.forEach(item => {
      if (item.type === "navItem"){
        var prefix = path === '' ? '' : "/" + path;
        routes.push({ routeName: prefix + '/' + item.name.replace(/\s+/g, ''), src: item.src});
      }
      else if (!!item.items) {
        this.getAllRoutesRecursive(item.items, item.name.replace(/\s+/g, ''), routes);
      }
    });
  }

  getAllRoutes = () => {
    var items = JSON.parse(JSON.stringify(this.navigationData().items));
    var routeData = []
    this.getAllRoutesRecursive(items, '', routeData);
    return routeData;
  }

  generateRoutes = () => {
    var routes = this.getAllRoutes().map((route, i) => {
      return <Route exact path={route.routeName} render={ () => <LinkPage key={ route.routeName + i } src={route.src}/> } />;
    });

    return(
      <>
        {routes}
      </>
    )
  }
  render () {
    return(
      <div className='blog'>
        <div className='flex-container'>
          {this.navigation()}
          <Route exact path="/" render={ () => <div style={{ color: 'black', width: '100%', height: '100%'}}/> } />
          {this.generateRoutes()}
        </div>
        {this.navigationIcon()}
      </div>
    )
  }
}

export default compose(
  withRouter,
  connect(state =>
    { return {
      navigationData: state.data,
    };},
    {fetchNavigationData,})
)(Blog);
